import {CheckIcon} from '@primer/octicons-react'
import {ReviewState, type CompletedReview} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'
import type {Thread} from '@github-ui/diff-lines/conversation-types'

import {ForYouItem} from '../shared/ForYouItem'
import {useOverviewBranchActions} from '../mergeability/shared/use-overview-branch-actions'

export function shouldShowCommentsResolved(review: CompletedReview | undefined, reviewThreads: Thread[]): boolean {
  const hasFeedbackReview = review?.state === ReviewState.COMMENTED || review?.state === ReviewState.CHANGES_REQUESTED
  return hasFeedbackReview && reviewThreads.length > 0 && reviewThreads.every(thread => thread.isResolved)
}

export function CommentsResolved() {
  const branchActions = useOverviewBranchActions('comments-resolved')

  return (
    <ForYouItem
      itemId="comments-resolved"
      visual={{kind: 'icon', icon: CheckIcon, tone: 'success', glyphSize: 16}}
      title="Comments resolved"
      subText="All of your comment threads have been resolved."
      actions={branchActions}
    />
  )
}
